import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BuilderService } from '@app/modules/builder/base/services';
import { SessionService, AccountService, LookupsService, ConstantsService, EnvironmentService } from '@app/core/services';
import { SocoHttpService } from '@app/base/soco';
import { BuilderInfo, BuilderLoginAuditModel } from '@app/core/models';
import { DatePipe } from '@angular/common';

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'app-builder',
  templateUrl: './builder.component.html',
  styleUrls: ['./builder.component.css'],
  // since builderservice was needed in create lot and request lot component, had to delcare in the builder module
  // providers: [BuilderService]
})
export class BuilderComponent implements OnInit {
  public company: string;
  public userId: string;
  public email: string;
  public city: string;
  public builderInfo: BuilderInfo = {
    Admin: false,
    BuilderId: [],
    IsActive: '',
    subsidiaryId: [],
    CompanyName: '',
    subsidiaryList: [],
    CompanyAddress: {
    id: '',
    contactTypeCode: '',
    streetNumber: '',
    recUpdatedDate: '',
    recCreatedDate: '',
    recCreatedBy: '',
    recUpdatedBy: '',
    streetName: '',
    directionPrefix: '',
    directionSuffix: '',
    streetType: '',
    city: '',
    state: '',
    zipCode: '',
    contactName2Extn: '',
    contactName1Phone: '',
    contactName1AreaCode: '',
    contactName2AreaCode: '',
    contactName2Phone: '',
    address2: '',
    unitNumber: ''
  },
    CompanyEmail: '',
    BuilderMapping: [{id: '', builderName: '', subsidiaryId: [], subsidiaryName: [], status: ''}]
};
 public subsidaryList = [];
 public address1: string;
 public address2: string;
 public contactNumber: string;
 public state: string;
 public cityValues;
 public stateValues;
 public userName: string;
 public emailId: string;
 public builderLoginAudit: BuilderLoginAuditModel;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public session: SessionService,
    private http: BuilderService,
    public accountSvc: AccountService,
    private lookupSvc: LookupsService,
    public socoHttp: SocoHttpService,
    public constSvc: ConstantsService,
    private environment: EnvironmentService,
    private datePipe: DatePipe
  ) {}
  ngOnInit() {
    this.userName = this.accountSvc.account.user.username;
    this.emailId = this.accountSvc.account.user.email;
    this.builderLoginAudit = new BuilderLoginAuditModel;
    this.builderDataLoad();

}

  // code to fetch builder data
  builderDataLoad() {
    if (this.userName !== undefined) {
    this.http.getBuilderInfo(this.accountSvc.account.user.company).subscribe(
      result => {
        if (result.data !== undefined) {
        if (result.data.length !== 0) {
          this.builderInfo.BuilderId.push(result.data.id);
          this.builderInfo.CompanyName = result.data.companyName;
          this.builderInfo.CompanyEmail = result.data.email;
          this.builderInfo.CompanyAddress = result.data.builderAddresses;
            this.builderInfo.Admin = true;
            for (let i = 0; i < result.data.builderMapping.length; i++) {

                this.builderInfo.subsidiaryList.push({ id: i, itemName: result.data.builderMapping[i].subsidiaryName });
                this.builderInfo.subsidiaryId.push(result.data.builderMapping[i].subsidiaryId);
                this.builderInfo.BuilderId.push(result.data.builderMapping[i].subsidiaryId);


            }
            this.builderInfo.BuilderMapping = result.data.builderMapping;
            
          const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
            if (subscribe && val) {
              subscribe.unsubscribe();
            }
            if (val) {
              this.cityValues = this.lookupSvc.cities;
              this.stateValues = this.lookupSvc.states;
              if ((this.builderInfo.CompanyAddress.state != null && this.builderInfo.CompanyAddress.state !== '')
              && this.cityValues !== undefined) {
                this.state = this.stateValues.find(x => x.id === this.builderInfo.CompanyAddress.state ).itemName;
              }

              if ((this.builderInfo.CompanyAddress.city != null && this.builderInfo.CompanyAddress.city !== '')
                && this.stateValues !== undefined) {
                this.city = this.cityValues.find(x => String(x.id) === this.builderInfo.CompanyAddress.city ).itemName;
             }
             if (this.city && this.state) {
              this.address2 = this.city + ', ' + this.state + ' ' + this.builderInfo.CompanyAddress.zipCode;
             } else {
               this.address2 = '';
             }
            }
          });

          this.company = this.builderInfo.CompanyName;
          this.email = this.builderInfo.CompanyEmail;
          this.address1 = this.builderInfo.CompanyAddress.streetNumber + ' ' + this.builderInfo.CompanyAddress.streetName ;
          this.contactNumber = this.builderInfo.CompanyAddress.contactName1Phone ?
          this.builderInfo.CompanyAddress.contactName1Phone.replace(/-/g, '')
                    .replace(/^([0-9]{3})([0-9]{3})([0-9]{4})$/, '$1-$2-$3') : '';


          this.builderLoginAudit.CompanyName = this.builderInfo.CompanyName;
          this.builderLoginAudit.BuilderId = result.data.id;
          let givenName = this.accountSvc.account.user.givenName.split(', ');
          this.builderLoginAudit.FirstName = givenName[0];
          this.builderLoginAudit.LastName = givenName[1];

          // Sets the builder end access date to six months after account creation
          let dateObj = new Date(result.data.recCreateDate);
          dateObj.setMonth(dateObj.getMonth() + 6);
          this.builderLoginAudit.EndDate = this.datePipe.transform(dateObj.toISOString(), 'dd-MMM-yy HH:mm:ss');

          this.builderLoginAudit.LastAccess = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss');
          this.builderLoginAudit.UserName = this.accountSvc.account.user.username;
          this.addBuilderLoginAudit();

          this.passBuilderData();
          if (this.cityValues && this.stateValues) {

          }

        } else {
          this.address2 = '';
          this.address1 = '';
          this.email = '';
          this.contactNumber = '';
        }
        } else {
         this.logoff();
        }
      },
        error => {
         this.logoff();
      }
    );
    } else {
      this.address2 = '';
      this.address1 = '';
      this.email = '';
      this.contactNumber = '';
    }
  }
// code to pass builder data fetched from DB to service
passBuilderData() {
  this.session.GetBuilderData(this.builderInfo);
}
public individualServiceLineClicked() {
  this.http.individualServiceClicked = true;
}
public logoff() {
  const url = '/' + (this.environment.isSoCoEnv ? 'account/logoff' : (this.constSvc.localIISAppName + '/account/logoff'));
  swal(this.constSvc.builderErrorSwal, '', this.constSvc.errorSwal).then(() => {
  window.location.href = url;
  });
    }

    addBuilderLoginAudit() {
        const subscribe = this.http.AddBuilderLoginAudit(this.builderLoginAudit).subscribe(result => {
            if (subscribe && result.status) {
                subscribe.unsubscribe();
            }
        });
    }
}
